module.exports = __webpack_public_path__ + "static/media/fighter.7a08920b.png";